<template>
  <AppLogo class="layout-error" />
  <!-- eslint-disable-next-line vue/no-multiple-template-root -- component, not a Nuxt layout -->
  <div class="layout-error__inner">
    <div class="layout-error__content">
      <div class="layout-error__wrapper">
        <AppHeadingResizing
          :key="headingKey"
          :label="is404 ? 'Helaas {{deze pagina}} kunnen we niet vinden.' : 'Helaas er is {{iets mis}} gegaan.'"
          :animate="true"
          :indented="true"
          class="layout-error__heading-resizing"
        />
      </div>
      <div class="layout-error__container">
        <AppButton url="/" title="Home" />
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// check for showPlaceholder. if true, we'll use the error page as a placeholder.
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useError, useHead } from 'nuxt/app'
import { throttle } from '~/utils/throttle-debounce'
import { useAnimatedTitleStore } from '~/store/animated-title'
import { AppLogo } from '#components'

const headingKey = ref(0)
const animatedTitleStore = useAnimatedTitleStore()
const error = useError()

useHead({ title: `Error ${error.value.statusCode}: ${error.value.message}` })

function rerenderHeading () {
  throttle(headingKey.value += 1, 1000)
}

const is404 = computed(() => { return error.value.statusCode === 404 })

onMounted(() => {
  if (process.client) {
    animatedTitleStore.fontsReady = true
  }
  window.addEventListener('resize', rerenderHeading)
  document.body.style.overflow = 'hidden'
})

onUnmounted(() => {
  window.removeEventListener('resize', rerenderHeading)
  document.body.style.overflow = 'auto'
})
</script>

<style scoped lang="postcss">
.layout-error {
  position: fixed;
  left: 1.25rem;
  top: 1.25rem;
  width: 52px;
  color: var(--color-blue-aqua);
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    color: #fff;
  }

  @media (--md) {
    left: 40px;
  }

  &__inner {
    display: flex;
    min-height: 100dvh;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }

  &__content {
    @mixin container;
    gap: 2.5rem;
    @mixin app-container-padding;
    @mixin app-grid;

    @media (--lg) {
      gap: 3.5rem;
    }
  }

  &__wrapper {
    grid-column: 1 / -1;
  }

  &__heading-resizing {
    color: var(--color-blue-aqua);
    @mixin heading-h1-xl;
  }

  &__container {
    @mixin app-layout-container-column;
  }
}
</style>
